export const Info = {
  documentError: 'Unable to get document details',
  getActivityError: 'Unable to get Activity details',
  loanDetailsError: 'Unable to get Loan details',
  loanInformationError: 'Unable to get Loan information',
  showNav: 'Show Navigation',
  hideNav: 'Hide Navigation',
  loanOfficer: 'Loan Officer',
  toogleClass: 'bl-nav-open',
  appNumber: 'appNumber',
  pdfMemeType: 'application/pdf',
  htmlMemeType: 'text/html',
  readytofund: 'Ready to Fund',
  helocdisclosure: 'helocdisclosure',
  underReview: 'Under Review',
  initialDisclosure: 'Initial Disclosure',
  sign: 'Sign',
  passwordException: 'PasswordException',
  passwordErrorMessage: 'This document is password protected. Enter the password:',
  upload: 'Upload',
  documentTaskError: 'Unable to get document task',
  error: 'error',
  document: 'document',
  modalOpen: 'modal-open',
  clickableTarget: 'clickable-target',
  mail: 'mail',
  fax: 'fax',
  eSignReturnUrl: '/integration/document-esign',
  oaoeSignReturnUrl: '/integration/oao/document-esign?sid=',
  closeModal: 'closeModal',
  optionalReviewFieldText: '<span class="bl-font-color--primary">Optional</span>',
  dropzone: 'dropzone',
  blank: '_blank',
  position: 'top=0,left=0,height=100%,width=auto',
  isLoaded: `<script> function isLoaded() { setTimeout(function(){ var pdfFrame = window.frames["pdf"];
    pdfFrame.focus(); pdfFrame.print(); pdfFrame.close();},1000); } </script> `,
  read: 'Read',
  showNavigation: 'Show Navigation',
  hideNavigation: 'Hide Navigation',
  navOpenClass: 'bl-nav-open',
  notImplementError: 'Method not implemented.',
  success: 'success',
  warning: 'warning',
  HomeAddress: 'HomeAddress',
  file: 'file',
  comments: 'comments',
  all: 'all',
  radioPreTag: `<cu-radio-legacy name = 'radioGroup' [options] = \"[ { label: 'Male', value: false },
    { label: 'Female', value: false } ]\" [ ( ngModel ) ]='sex'><\/cu-radio-legacy>`,
  style: 'style',
  click: 'click',
  fileId: '#file',
  locked: 'locked',
  unlocked: 'Unlocked',
  float: 'not locked',
  primaryBorrower: 'PrimaryBorrower',
  jointPrimaryBorrower: 'JointPrimaryBorrower',
  fixedYear: '30 Years Fixed',
  pdfContainerStyle: 'overflow-x:unset !important; position: relative;',
  optionsPreTag: ` [ { label: 'Male', value: false } , { label: 'Female', value: false } ] `,
  accountNumber: 'accountNumber',
  accountType: 'accountType',
  financialInstitution: 'financialInstitution',
  routing: 'routing',
  loanStatus: 'loanstatus',
  submitStatus: 'submitstatus',
  onTrack: 'On Track',
  completedLoanPercentage: 'completedLoanPercentage',
  iframePrefix: '<iframe onload="isLoaded()" id="pdf" name="pdf" src=\'',
  iframeSuffix: '\' width="100%" height="100%"></iframe>',
  documentPrefix: '\n <html>\n <head>\n<title>Print Document</title>\n</head>\n<body>',
  documentSuffix: '</body>\n  </html>',
  home: 'Home',
  cell: 'Cell',
  documentSuccess: 'DocumentSuccess',
  todo: 'todo',
  body: 'body',
  cuSpinnerBgColor: '#d5dee3',
  allowedRoute: 'AllowedRoute',
  accountErrorMessage: `Something went wrong and we can't create your account right now.
    We apologize for the inconvenience. Please try again later.`,
  // eslint-disable-next-line max-len
  accountAlreadyExistMsg: `This email address is associated with an existing account. Use a different address or log in <a href="./user/login@flowType">here</a> to continue your application.`,
  loginErrorMessage: `We're having a technical issue now. Please come back to log in later.`,
  uploadSuccess: 'Document uploaded successfully',
  unableToUpload: 'Unable to Upload Document',
  cancelsubmit: 'cancelsubmit',
  consentDocument: '/assets/document/econsent.html',
  // eslint-disable-next-line max-len
  registrationAcknowledgment: `<span class="bl-display--inline-block">I acknowledge and agree to eConsent and to the Terms of Use, and Privacy Policy listed above.</span>`,
  qfileid: 'qfileid',
  borrowerid: 'borrowerid',
  datasourceid: 'datasourceid',
  loannumber: 'loannumber',
  defaultLogin: 'Welcome123!',
  queued: 'queued',
  uploaded: 'uploaded',
  documentRequest: 'documentRequest',
  consentCheckLabel: `I acknowledge and agree to eConsent and to the Terms of Use, and Privacy Policy listed above. `,
  // eslint-disable-next-line max-len
  consentCheckLabelPefix: `I acknowledge and agree to <a target="_blank" href='/legal/econsent-only'> eConsent </a> and to the <a target="_blank" href='/legal/terms-of-use'>Terms of Use</a>, and <a target="_blank" href='/legal/privacy-policy'>Privacy Policy</a> listed above. `,
  defaultPricingOfferDescription:
    // eslint-disable-next-line max-len
    'Estimated monthly payments do not include taxes and property insurance. With the addition of these required costs, your total financial obligation will typically be higher than the payments listed here. Estimated monthly payments can include mortgage insurance (MI) when Loan-to-value (LTV) is over 80%. Check here for <a target="_blank" href="#lenderUrl#"> promotional offers and fees</a>.',
  content: 'content',
  shown: 'shown',
  hidden: 'hidden',
  formReset: 'formReset',
  formSignin: 'formSignin',
  formResetNew: 'formResetNew',
  formSignUp: 'formSignUp',
  emailConfirm: 'Confirm email address',
  email: 'Email address',
  imgRemoveConfirm: 'Are you sure you want to remove this photo?',
  password: 'Password',
  added: 'added',
  // eslint-disable-next-line id-blacklist
  string: 'string',
  user: 'user',
  username: 'Username',
  CitiBank: 'CitiBank',
  American: 'American National Credit Union',
  hostNotDefined: 'Host data not defined',
  invalidType: 'Invalid Loan Type',
  clickMe: 'Click me',
  emailStr: 'Email',
  ball: 'ball-scale-multiple',
  large: 'large',
  small: 'small',
  medium: 'medium',
  lasm: 'la-sm',
  la2x: 'la-2x',
  la3x: 'la-3x',
  la: 'la-',
  hide: 'hide',
  show: 'show',
  BPMAccordion: 'BPM.Accordion',
  consumerPortal: 'consumerPortalApi',
  refer: 'refer',
  lastSessionToken: 'lastSessionToken',
  exception: 'exception',
  contactLender: 'contactLender',
  loanStatusAuto: 'loanStatus/auto/',
  validDate: 'Please enter a valid date (MM/DD/YYYY)',
  ageGreater: 'You must be 18 years or older to register.',
  validEmail: 'Please enter a valid email address',
  validSSN: 'Enter the last 4 digits of your SSN or ITIN',
  logout: 'logout',
  ssnObfuscatedValue: '***-**-****',
  einObfuscatedValue: '**-*******',
  eSigned: 'eSigned',
  interviewer: 'Interviewer',
  radio: 'radio',
  yesNo: 'yes-no',
  submitted: 'submitted',
  failed: 'failed',
  oaoSubmitListener: 'submitApplicationListener'
};

export const ElementClassName = {
  body: 'body',
  bodyFooter: 'body-footer',
  displayNone: 'bl-display--none',
  documentReviewContainer: 'document-review-container',
  fontColorBase: 'bl-font-color--base',
  fontColorSuccess: 'bl-font-color--success',
  fontColorWarning: 'bl-font-color--warning',
  modelOpen: 'modal-open',
  pdfViewerContainer: 'ng2-pdf-viewer-container',
  portalContent: 'portal-content',
  scroll: 'scroll',
  textSuccess: 'text-success',
  documentMouseup: 'document:mouseup',
  documentPanend: 'document:panend',
  btnClass: 'bl-button animated-trans',
  bdColor: 'rgba(51,51,51,0)',
  color: '#fff',
  textWarning: 'text-warning',
  imgName: 'img',
  propimgupload: 'propimgupload',
  modalContainer: 'modal-container',
  idleTimerPopup: 'idle-timer-popup',
  modalBackdrop: 'modal-backdrop',
  bsModalBackdrop: 'bs-modal-backdrop',
  zeroPx: '0px'
};

// USE THIS FOR DICTIONARY STRING
export const Dict_Const = {
  document: {
    all: 'document/all',
    completed: 'document/completed',
    inreview: 'document/inreview',
    reupload: 'document/reupload',
    review: 'document/review',
    sign: 'document/sign',
    todo: 'document/todo',
    upload: 'document/upload',
    read: 'document/read',
    signComplete: 'document/signComplete',
    signDeclined: 'document/signDeclined',
    done: 'document/done'
  },
  documentTodo: {
    go: 'documentTodo/go',
    review: 'documentTodo/review',
    sign: 'documentTodo/sign',
    upload: 'documentTodo/upload',
    read: 'documentTodo/read',
    pay: 'documentTodo/pay'
  },
  loanStatus: {
    auto: 'loanStatus/auto/',
    creditCard: 'loanStatus/creditCard/',
    personal: 'loanStatus/personal/'
  },
  timeLineInfo: {
    completeAll: 'timeLineInfo/completeAll',
    completeAllWithLink: 'timeLineInfo/completeAllWithLink',
    completeOverdue: 'timeLineInfo/completeoverdue',
    completeallHeloc: 'timeLineInfo/completeallHeloc',
    completeallHelocWithLink: 'timeLineInfo/completeallHelocWithLink',
    daysLeft: 'timeLineInfo/daysleft',
    thanksCompleting: 'timeLineInfo/thankscompleting',
    unableToEst: 'timeLineInfo/unabletoest',
    unableToFund: 'timeLineInfo/unabletofund'
  },
  personalInfoAutofill: {
    disclaimer: 'personalInfoAutofill/disclaimer'
  }
};

export const StipulationInfo = {
  stipulationDesc: 'stipulationDesc',
  stipulationId: 'stipulationId'
};

export const DropzoneConfig = {
  acceptedFiles: '.png,.jpg,.jpeg,.pdf',
  clickable: '#clickable-target',
  dictCancelUpload: 'Cancel Upload',
  dictCancelUploadConfirmation: 'Are you sure to cancel to upload this file?',
  dictRemoveFileConfirmation: 'Are you sure to remove this file?',
  previewTemplate: `<div class="bl-display-sm--flex bl-border-top--solid
    bl-margin-x-sm--16 bl-padding-y--16 bl-margin-bottom--16 bl-overflow--hidden">
    <div class="bl-width--100 bl-width-sm--25 bl-padding-right-sm--16 bl-margin-bottom--16 bl-margin-bottom-sm--0">
      <img class="bl-display--block bl-margin-x--auto bl-margin-top--4"
        src="assets/images/pdf@3x.png"
        onerror="this.src='assets/images/no_image.png';"
        data-dz-thumbnail />
    </div>
    <div class="bl-width--100 bl-width-sm--75 bl-align-items--center">
      <p class="bl-margin-bottom--0 bl-font-size--14 bl-overflow-wrap--break-word" data-dz-name></p>
      <div class="dz-progress bl-padding-right--8 bl-margin-top--4 bl-display--none">
        <span class="dz-upload bl-bg-color--primary" data-dz-uploadprogress></span>
      </div>
      <p class="bl-margin-top--4 bl-margin-bottom--0">
        <i class="dz-success-icon cu-check-circle-solid bl-font-color--success bl-margin-right--4"></i>
        <span class="bl-font-size--14 bl-margin-bottom--0" data-dz-size></span>
      </p>
      <div class="dz-errors bl-margin-top--4">
        <p class="bl-font-color--error bl-display--flex bl-align-items--flex-start">
          <i class="cu-warning-solid bl-font-size--16 bl-font-color--error bl-margin-right--8 bl-margin-top--4"></i>
          <span class="bl-font-size--14 bl-font-color--error" data-dz-errormessage></span>
        </p>
      </div>
      <button class="remove bl-font-color--slate bl-display--flex bl-align-items--center bl-margin-top--16" data-dz-remove>
      <i class="cu-trash-can bl-margin-right--8"></i>Remove</button>
    </div>
  </div>`
};

export const ImageUrl = {
  default: 'assets/images/no_image.png',
  autoDefault: 'assets/images/auto-circle-icon.svg',
  creditCard: 'assets/images/credit-card-circle-icon.svg',
  personal: 'assets/images/personal-loan-circle-icon.svg',
  heloc: 'assets/images/heloc-circle-icon.svg',
  homeEquity: 'assets/images/homeequityloan-circle-icon.svg',
  purchase: 'assets/images/purchase-new-circle-icon.svg',
  refinance: 'assets/images/refinance-new-circle-icon.svg',
  oaoBusiness: 'assets/images/oao-business-circle-icon.svg',
  oaoPersonal: 'assets/images/oao-personal-circle-icon.svg',
  oaoYouth: 'assets/images/oao-youth-circle-icon.svg'
};

export const DropzoneError = {
  dzErrors: '.dz-errors span',
  fileType: 'files of this type',
  DocTypeNotSupport: 'File type not allowed. Please upload a PDF, JPG or PNG',
  imgNotSupport: 'File type not allowed. Please upload a JPEG, JPG or PNG',
  maxFileSize: 'Max filesize',
  fileSizeExceeds: 'File size exceeds 10 MB limit.',
  fileSizeExceeds30: 'File size exceeds 30 MB limit.',
  errorClass: '.dz-errors',
  none: 'd-none'
};

export const StatusSummary = {
  approvedSummary: 'approvedSummary',
  underreviewSummary: 'underreviewSummary',
  readyToFundSummary: 'readyToFundSummary',
  fundedSummary: 'fundedSummary',
  emptyTodo: 'emptyTodo',
  riskSummary: 'riskSummary',
  contactLenderSummary: 'contactLenderSummary',
  withdrawnSummary: 'withdrawnSummary',
  trackSummary: 'trackSummary',
  trackSummaryWithLink: 'trackSummaryWithLink',
  pendingSummary: 'pendingSummary',
  incompleteAppSummary: 'incompleteAppSummary',
  counterOfferedSummary: 'counterOfferedSummary',
  declinedSummary: 'declinedSummary'
};

export const RouterUrlConstant = {
  userProfile: '/user/profile',
  apiLoginUrl: 'account/login',
  application: '/mortgage/application',
  mortgagePostapp: '/mortgage/postapp',
  consumerPostapp: '/consumer/postapp',
  oaoPostapp: '/oao/postapp',
  Dashboard: '/consumer/dashboard',
  RegistrationLight: '/user/light-registration',
  Login: '/user/login',
  Econsent: '/user/econsent',
  dashboard: '/consumer/dashboard'
};

export const ModalPopup = {
  upload: '#upload-modal_',
  review: '#review-modal_',
  payment: '#payment_modal_',
  address: '#update-address',
  outpayment: '#outpayment_modal_',
  ratelock: '#rate-lock'
};

export const RequestHeaderConst = {
  accept: `Accept`,
  cancel: 'Cancel',
  contentType: 'text/html',
  contentTypeName: 'Content-Type',
  authorization: 'Authorization',
  dxSessionId: 'Session-Id',
  methodType: 'GET',
  multipart: 'multipart/form-data',
  allowHeaderName: 'Access-Control-Allow-Headers',
  allowHeaderValue: 'Origin, Content-Type, X-Auth-Token',
  allowOriginName: 'Access-Control-Allow-Origin',
  allowOriginValue: '*',
  cacheControlName: 'Cache-Control',
  cacheControlValue: 'no-cache',
  https: 'https://',
  http: 'http://',
  responseType: 'blob',
  apiVersion: 'x-api-version',
  pragma: 'Pragma',
  origin: 'ArcDX-Origin'
};

export const InputParamName = {
  disabled: 'disabled',
  hideValues: 'hide-values',
  hideTooltip: 'hide-tooltip',
  step: 'step',
  maxSelected: 'maxSelected',
  minSelected: 'minSelected',
  max: 'max',
  min: 'min'
};

export const AccordionGroup = {
  template: `
  <div [class.dropup]="isOpened" [class.disabled]="disabled">
    <div class="accordion-header">
        <label class="bl-font-size--12 accordion-text container card-arrow-show-property bl-font-size--14" role="tab"
         [ngClass]="{'collapsed':!isOpened,'bl-font-weight--900':isOpened}" (click)="checkAndToggle()">
            <a *ngIf="heading" role="button" data-toggle="collapse"  [attr.aria-expanded]="isOpened">
                {{ heading }}
            </a>
            <ng-content select="cu-accordion-heading"></ng-content>
        </label>
    </div>
        <div class="panel-collapse collapse in accordion-sup-top" #acc_body [ngClass]="{'show':isOpened}" role="tabpanel"
        [attr.aria-labelledby]="heading">
            <ng-content></ng-content>
        </div>
  </div>
`
};

export const MY_FORMATS = {
  display: {
    dateA11yLabel: 'LL',
    dateInput: 'MM/DD/YYYY',
    monthYearA11yLabel: 'MMMM YYYY',
    monthYearLabel: 'MMM YYYY'
  },
  parse: {
    dateInput: 'MM/DD/YYYY'
  }
};

export const Cryptor = {
  criptor_key: 'Ck&Av(1WUoZ#6<C<',
  textIv: '4321123412344321',
  textKey: '0123321001233210'
};

export const LocalStorageKeys = {
  userStorageName: 'BPM.User',
  userloanselection: 'BPM.Consumer',
  allowedRoute: 'AllowedRoute',
  BPMConsumer: 'BPM.Consumer',
  BPMAccordion: 'BPM.Accordion',
  flowType: 'BMP.FlowType',
  featuresStorageName: 'Admin.Features'
};

export const AlertStatus = {
  error: 'error',
  info: 'info',
  success: 'success',
  warning: 'warning'
};

export const LoginConstant = {
  application: 'application',
  postApplication: 'postapplication'
};

export const PostAppSessionProps = {
  loanType: 'loanType',
  loanProductName: 'loanProductName',
  loanGroupIcon: 'loanGroupIcon',
  loanProductDisplayName: 'loanProductDisplayName',
  applicants: 'applicants',
  membershipTypeName: 'membershipTypeName',
  isYouthMembership: 'isYouthMembership',
  appStatus: 'appStatus',
  loanStatus: 'loanStatus',
  loanStatusDescription: 'loanStatusDescription',
  statusMessage: 'statusMessage',
  accountNames: 'accountNames',
  accountsNamesLabel: 'accountsNamesLabel',
  sourceLoanType: 'sourceLoanType',
  membershipStatus: 'membershipStatus',
  requestedLoanAmount: 'requestedLoanAmount',
  decision_amount: 'decision.amount',
  decision_rate: 'decision.rate',
  decision_term: 'decision.term',
  selectedLoanProduct: 'selectedLoanProduct',
  decision_estMonthlyPayment: 'decision.estMonthlyPayment',
  postAppStatusMessage: 'postAppStatusMessage',
  isPostAppNotificationActive: 'isPostAppNotificationActive',
  postAppNotificationMessage: 'postAppNotificationMessage'
};
